import './style.css'

const $ = (selector, scope = document) => scope.querySelector(selector)
const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)]
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

const toast = $('#toast')
let toastTimer

function showToast(message, tone = 'success') {
  clearTimeout(toastTimer)
  $('span', toast).textContent = message
  $('i', toast).style.background = tone === 'error' ? '#ff5148' : '#c8ff00'
  toast.classList.add('visible')
  toastTimer = window.setTimeout(() => toast.classList.remove('visible'), 4200)
}

// Header and navigation
const header = $('[data-header]')
const menuButton = $('.menu-button')
const mobileMenu = $('#mobileMenu')

function closeMenu() {
  menuButton.setAttribute('aria-expanded', 'false')
  menuButton.setAttribute('aria-label', 'Open navigation')
  mobileMenu.classList.remove('open')
  mobileMenu.setAttribute('aria-hidden', 'true')
}

menuButton.addEventListener('click', () => {
  const willOpen = menuButton.getAttribute('aria-expanded') !== 'true'
  menuButton.setAttribute('aria-expanded', String(willOpen))
  menuButton.setAttribute('aria-label', willOpen ? 'Close navigation' : 'Open navigation')
  mobileMenu.classList.toggle('open', willOpen)
  mobileMenu.setAttribute('aria-hidden', String(!willOpen))
})

$$('a', mobileMenu).forEach((link) => link.addEventListener('click', closeMenu))
window.addEventListener('resize', () => {
  if (window.innerWidth > 1120) closeMenu()
})

// Reveal system
$$('[data-delay]').forEach((element) => {
  element.style.setProperty('--delay', `${element.dataset.delay}ms`)
})

if (prefersReducedMotion) {
  $$('.reveal-up').forEach((element) => element.classList.add('visible'))
} else {
  const revealObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.add('visible')
        observer.unobserve(entry.target)
      })
    },
    { threshold: 0.12, rootMargin: '0px 0px -50px' },
  )
  $$('.reveal-up').forEach((element) => revealObserver.observe(element))
}

// Parallax and real two-frame wink. Scroll depth and pointer tilt are kept on
// separate DOM layers so their transforms never overwrite one another.
const hero = $('.hero')
const foxTilt = $('#foxTilt')
const foxDepth = $('#foxDepth')
const foxPortrait = $('#foxPortrait')
const parallaxLayers = $$('[data-parallax]')
let scrollTicking = false
let winkTimer
let lastScrollY = window.scrollY
let scrollDistanceSinceWink = 0
let hasScrollWinked = false
let lastWinkAt = 0

function wink() {
  lastWinkAt = performance.now()
  scrollDistanceSinceWink = 0
  clearTimeout(winkTimer)
  foxPortrait.classList.remove('winking')
  void foxPortrait.offsetWidth
  foxPortrait.classList.add('winking')
  winkTimer = window.setTimeout(() => foxPortrait.classList.remove('winking'), 760)
}

function updateScrollMotion() {
  const rect = hero.getBoundingClientRect()
  const heroTravel = Math.max(hero.offsetHeight - window.innerHeight * 0.35, 1)
  const progress = Math.max(0, Math.min(1, -rect.top / heroTravel))
  const currentScrollY = window.scrollY
  const scrollDelta = Math.abs(currentScrollY - lastScrollY)

  header.classList.toggle('scrolled', currentScrollY > 18)

  if (!prefersReducedMotion) {
    foxDepth.style.transform = `translate3d(0, ${progress * 34}px, 0) rotateZ(${progress * 1.8}deg) scale(${1 - progress * 0.035})`

    parallaxLayers.forEach((layer) => {
      const speed = Number(layer.dataset.parallax || 0)
      layer.style.transform = `translate3d(${currentScrollY * speed}px, 0, 0)`
    })

    scrollDistanceSinceWink += scrollDelta
    const heroIsVisible = rect.bottom > 80 && rect.top < window.innerHeight
    const firstScrollReached = !hasScrollWinked && currentScrollY >= 24
    const repeatScrollReached = hasScrollWinked && scrollDistanceSinceWink >= 260 && performance.now() - lastWinkAt >= 900

    if (heroIsVisible && (firstScrollReached || repeatScrollReached)) {
      hasScrollWinked = true
      wink()
    }
  }

  lastScrollY = currentScrollY
  scrollTicking = false
}

function requestScrollUpdate() {
  if (scrollTicking) return
  scrollTicking = true
  window.requestAnimationFrame(updateScrollMotion)
}

window.addEventListener('scroll', requestScrollUpdate, { passive: true })
window.addEventListener('resize', requestScrollUpdate, { passive: true })
updateScrollMotion()

if (!prefersReducedMotion) {
  $('.hero-visual').addEventListener('pointermove', (event) => {
    if (event.pointerType === 'touch') return
    const bounds = foxTilt.getBoundingClientRect()
    const x = (event.clientX - bounds.left) / bounds.width - 0.5
    const y = (event.clientY - bounds.top) / bounds.height - 0.5
    foxTilt.style.transform = `rotateX(${-y * 8}deg) rotateY(${x * 10}deg)`
  })
  $('.hero-visual').addEventListener('pointerleave', () => {
    foxTilt.style.transform = 'rotateX(0deg) rotateY(0deg)'
  })
}

$('#winkTrigger').addEventListener('click', wink)

// Alpha desk filtering
$$('[data-filter]').forEach((button) => {
  button.addEventListener('click', () => {
    $$('[data-filter]').forEach((item) => item.classList.remove('active'))
    button.classList.add('active')
    const filter = button.dataset.filter
    $$('[data-signal]').forEach((row) => {
      row.classList.toggle('hidden', filter !== 'all' && row.dataset.signal !== filter)
    })
  })
})

// Small terminal heartbeat; the terminal remains clearly marked as simulation.
const blockElement = $('[data-block]')
let demoBlock = 19_842_601
window.setInterval(() => {
  if (document.hidden) return
  demoBlock += Math.floor(Math.random() * 3) + 1
  blockElement.textContent = demoBlock.toLocaleString('en-US')
}, 4200)

// Waitlist preview state
const waitlistDialog = $('#waitlistDialog')
const waitlistButton = $('#joinWaitlist')
const storedWaitlistEmail = localStorage.getItem('hoodwink_waitlist_email')

if (storedWaitlistEmail) {
  waitlistButton.textContent = 'You’re on the early list ✓'
  waitlistButton.disabled = true
}

waitlistButton.addEventListener('click', () => waitlistDialog.showModal())
$('.dialog-close').addEventListener('click', () => waitlistDialog.close())
waitlistDialog.addEventListener('click', (event) => {
  if (event.target === waitlistDialog) waitlistDialog.close()
})

$('#waitlistForm').addEventListener('submit', (event) => {
  event.preventDefault()
  const email = $('#waitlistEmail').value.trim()
  localStorage.setItem('hoodwink_waitlist_email', email)
  waitlistButton.textContent = 'You’re on the early list ✓'
  waitlistButton.disabled = true
  waitlistDialog.close()
  showToast('Early-list signup saved on this device. Production endpoint comes with the domain.')
})

// Final details
$('#year').textContent = new Date().getFullYear()

$$('.magnetic').forEach((button) => {
  if (prefersReducedMotion) return
  button.addEventListener('pointermove', (event) => {
    const rect = button.getBoundingClientRect()
    const x = event.clientX - rect.left - rect.width / 2
    const y = event.clientY - rect.top - rect.height / 2
    button.style.transform = `translate(${x * 0.08}px, ${y * 0.12}px)`
  })
  button.addEventListener('pointerleave', () => {
    button.style.transform = ''
  })
})
